<template>
  <div style="width: 800px;">
    <label style="font-weight: bold; font-size: 18px">
      Knowledge
    </label>
    <br />
    <p>What knowledge do you have related to this area of interest?</p>

    <el-form @submit.native.prevent>
      <el-form-item
        :error="
          retrieveFieldError(
            modelState,
            'sgaKnowledge.KnowledgeRegularlyUsed[0].YearsOfExperience'
          )
        "
        :required="true"
      >
        <div class="ts-comp--multiselect columned">
          <div class="ts-comp--multiselect-item hide-sm">
            <label>&nbsp;</label>
            <div class="cols">
              <span>
                <img
                  src="~../../../../assets/img/icons/outsiderole_icon.svg"
                  alt="I add to role"
                />
                <strong>I add to role</strong>
              </span>
              <span class="col-wide">
                <strong>&nbsp;</strong>
              </span>
            </div>
          </div>
          <div
            v-for="(knowledge, index) in additionalKnowledge"
            :key="`knowledge-${index}`"
            class="ts-comp--multiselect-item"
          >
            <label>
              {{ knowledge }}
            </label>
            <div class="cols" v-if="KnowledgeRegularlyUsed[knowledge]">
              <span>
                <el-checkbox
                  @change="(v) => handleKnowledgeChange(knowledge, 'IN', v)"
                  v-model="KnowledgeRegularlyUsed[knowledge].in"
                ></el-checkbox>
              </span>
              <span class="col-wide">
                <el-select
                  placeholder="Years of experience"
                  size="mini"
                  :disabled="true"
                  v-model="KnowledgeRegularlyUsed[knowledge].experience"
                  @change="(v) => handleKnowledgeTChange(knowledge, v)"
                >
                  <el-option value="less than a year"
                    >Less than one year</el-option
                  >
                  <el-option value="1-2 years">1-2 years</el-option>
                  <el-option value="3-5 years">3-5 years</el-option>
                  <el-option value="5-10 years">5-10 years</el-option>
                  <el-option value="10+ years">10+ years</el-option>
                </el-select>
              </span>
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <el-alert
      v-if="KnowledgeError"
      :title="KnowledgeError"
      type="error"
      :closable="false"
    ></el-alert>
    <button
      class="ts-btn ts-btn-rounded ts-btn-secondary"
      @click="storeSection()"
    >
      Continue
    </button>
    <br />
    <a class="back-link" @click="goBack">
      <i class="fas fa-chevron-left"></i>Back
    </a>
    <br />
    <br />
    <br />
  </div>
</template>

<script>
export default {
  created() {
    
    this.fetchSession();

    if(this.currentCriteria.sgaKnowledge != null && this.currentCriteria.sgaKnowledge.knowledgeRegularlyUsed != undefined)
    {
        this.sgaKnowledge = this.currentCriteria.sgaKnowledge;
    }

    this.$store.dispatch("onet/additionalKnowledge", '15-1132.00')
    .then((res) => {
      
        this.$store
        .dispatch("sga/setAdditionalKnowledge", res)
        .then(() => {
          this.$nextTick(() => {
            
            if (!this.sgaKnowledge.knowledgeRegularlyUsed)
              this.$set(this.sgaKnowledge, "KnowledgeRegularlyUsed", {});
          });
          this.$forceUpdate();
        });
    });
  },
  destroyed() {},
  data() {
    return {
      modelState: {},
      sgaKnowledge: {
        knowledgeRegularlyUsed: [],
      },
      KnowledgeError: null,
    };
  },
  watch: {},
  computed: {
    currentCriteria() {
      return this.$store.state.apprentice.current_apprentice_criteria;
    },
    additionalKnowledge() {
      return this.$store.state.sga.additionalKnowledge;
    },
    KnowledgeRegularlyUsed: {
      get() {
        return Object.assign(
          {},
          ...Object.entries({ ...this.additionalKnowledge }).map((an) => {
            let oo = null;

            try {
              const fid = this.sgaKnowledge.knowledgeRegularlyUsed.find(
                (kru) => kru.selection === an[1]
              );
              if (fid) oo = fid;
            } catch (error) {}

            return {
              [an[1]]: {
                name: an[1],
                in: oo && oo.value.includes("IN"),
                out: oo && oo.value.includes("OUT"),
                experience:
                  oo && oo.yearsOfExperience ? oo.yearsOfExperience : null,
              },
            };
          })
        );
      },
      set(v) {
        // console.log(v);
      },
    },
    KnowledgeRegularlyUsedForSaving() {
      const ks = Object.keys(this.sgaKnowledge.knowledgeRegularlyUsed);
      return Object.values(this.sgaKnowledge.knowledgeRegularlyUsed).map(
        (i, v) => ({
          value: `${i.in === true ? "IN" : ""}${i.out === true ? "OUT" : ""}`,
          selection: ks[v],
          yearsOfExperience: i.exp,
        })
      );
    },
    currentMode() {
      return this.$store.state.sga.mode;
    },
  },
  methods: {
    fetchSession(){
      var parsed = JSON.parse(window.sessionStorage.getItem('currentCriteria'));
      if(parsed != null){
        this.currentCriteria.id = parsed.id;
        this.currentCriteria.subjectArea = parsed.subjectArea;
        this.currentCriteria.level = parsed.level;
        this.currentCriteria.pathway = parsed.pathway;
        this.currentCriteria.sgaHiddenExtras = (parsed.sgaHiddenExtras == null ? null : parsed.sgaHiddenExtras);
        this.currentCriteria.sgaKnowledge = (parsed.sgaKnowledge == null ? null : parsed.sgaKnowledge);
        this.currentCriteria.sgaSkills = (parsed.sgaSkills == null ? null : parsed.sgaSkills);
        this.currentCriteria.sgaMindset = (parsed.sgaMindset == null ? null : parsed.sgaMindset);
      }
    },
    storeSection() {
        
      //client side validation, initial records should not save in DB
      if (this.sgaKnowledge.knowledgeRegularlyUsed.length == 0) {
        this.KnowledgeError = "Please select at least 1 knowledge.";
        return false;
      } else {
        this.KnowledgeError = null;
      }

      this.currentCriteria.sgaKnowledge = this.sgaKnowledge;
      window.sessionStorage.setItem('currentCriteria', JSON.stringify(this.currentCriteria));
      this.$router.app.$emit("navigateToNextStep");
    },
    goBack() {
      this.$router.back();
    },
    handleKnowledgeChange(obj, val, a) {
        
      let oo = null;

      try {
        const fid = this.sgaKnowledge.knowledgeRegularlyUsed.findIndex(
          (wpa) => wpa.selection === obj
        );
        if (fid !== -1) oo = fid;
      } catch (error) {}

      if (oo == null) {
        this.sgaKnowledge.knowledgeRegularlyUsed.push({
          selection: obj,
          value: `${val}`,
          yearsOfExperience: 'less than a year',
        });
      } else {
        const v = this.sgaKnowledge.knowledgeRegularlyUsed[oo];
        if (v.value.includes(val)) {
          v.value = v.value.replace(val, "");
        } else {
          v.value = `${v.value}${val}`;
        }

        if (v.value === "") delete this.sgaKnowledge.knowledgeRegularlyUsed[oo];
        this.sgaKnowledge.knowledgeRegularlyUsed = this.sgaKnowledge.knowledgeRegularlyUsed.filter(
          Boolean
        );

        v.YearsOfExperience = 'less than a year';
      }
    },
    handleKnowledgeTChange(obj, val) {
      let oo = null;
      try {
        const fid = this.sgaKnowledge.knowledgeRegularlyUsed.findIndex(
          (wpa) => wpa.selection === obj
        );
        if (fid !== -1) oo = fid;
      } catch (error) {}

      if (oo !== null) {
        this.sgaKnowledge.knowledgeRegularlyUsed[oo].yearsOfExperience = 'Less than one year';
      }
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
  },
};
</script>

<style lang="scss">
</style>
